import APIClient from './index';
import _ from 'lodash';

const fail = (err, fallback) => _.get(err, 'data.error') || fallback;

export const startMomentRun = ({ message, threadRef }) =>
  APIClient.post('/Moments/agent/start', { message, threadRef })
    .then(response => response.data)
    .catch(err => Promise.reject(fail(err, 'Failed to reach the Moments Builder')));

// knownUpdatedAt echoes the last momentUpdatedAt this client rendered — an
// unchanged shop skips the server's slate hydration (products come back null).
export const pollMomentThread = (threadRef, knownUpdatedAt) =>
  APIClient.get(`/Moments/agent/threads/${encodeURIComponent(threadRef)}`, {
    params: knownUpdatedAt ? { knownUpdatedAt } : {}
  })
    .then(response => response.data)
    .catch(err => Promise.reject(fail(err, 'Failed to poll the build')));

export const listMoments = () =>
  APIClient.get('/Moments/agent/moments')
    .then(response => response.data)
    .catch(err => Promise.reject(fail(err, 'Failed to load moments')));

export const archiveMoment = momentId =>
  APIClient.post(`/Moments/${momentId}/archive`)
    .then(response => response.data)
    .catch(err => Promise.reject(fail(err, 'Failed to archive the moment')));

export const stopMomentRun = momentId =>
  APIClient.post(`/Moments/${momentId}/stop`)
    .then(response => response.data)
    .catch(err => Promise.reject(fail(err, 'Failed to stop the build')));

export const retryMomentRun = momentId =>
  APIClient.post(`/Moments/${momentId}/retry`)
    .then(response => response.data)
    .catch(err => Promise.reject(fail(err, 'Failed to retry the build')));

// Feature/unfeature on the shopper discover collage (all-scope admin only).
export const setMomentFeatured = (momentId, featured) =>
  APIClient.put(`/Moments/${momentId}/featured`, { featured })
    .then(response => response.data)
    .catch(err => Promise.reject(fail(err, 'Failed to update featured')));

export const setMomentProductState = (momentId, productId, state) =>
  APIClient.put(`/Moments/${momentId}/products/${productId}/state`, { state })
    .then(response => response.data)
    .catch(err => Promise.reject(fail(err, 'Failed to update the product')));

// Moment plans: recurring shops built for one shopper on a cadence.
export const listMomentPlans = () =>
  APIClient.get('/MomentPlans')
    .then(response => response.data)
    .catch(err => Promise.reject(fail(err, 'Failed to load the plans')));

export const createMomentPlan = plan =>
  APIClient.post('/MomentPlans', plan)
    .then(response => response.data)
    .catch(err => Promise.reject(fail(err, 'Failed to create the plan')));

export const updateMomentPlan = (planId, patch) =>
  APIClient.put(`/MomentPlans/${planId}`, patch)
    .then(response => response.data)
    .catch(err => Promise.reject(fail(err, 'Failed to update the plan')));

export const deleteMomentPlan = planId =>
  APIClient.delete(`/MomentPlans/${planId}`)
    .then(response => response.data)
    .catch(err => Promise.reject(fail(err, 'Failed to remove the plan')));

// Fires the plan now; the regular slot stays where it is.
export const runMomentPlanNow = planId =>
  APIClient.post(`/MomentPlans/${planId}/run`)
    .then(response => response.data)
    .catch(err => Promise.reject(fail(err, 'The plan did not deliver')));

export const listMomentShopAllowlist = () =>
  APIClient.get('/Moments/agent/feature_flag')
    .then(response => response.data)
    .catch(err => Promise.reject(fail(err, 'Failed to load the feature-flag allowlist')));

export const setSearchFeatureFlag = (userId, flagKey, enabled) =>
  APIClient.put('/Moments/agent/feature_flag', { userId, flagKey, enabled })
    .then(response => response.data)
    .catch(err => Promise.reject(fail(err, 'Failed to update the feature-flag allowlist')));

export const clearSearchFeatureFlags = userId =>
  APIClient.put('/Moments/agent/feature_flag', { userId, clear: true })
    .then(response => response.data)
    .catch(err => Promise.reject(fail(err, 'Failed to update the feature-flag allowlist')));
